import type { FC } from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"

interface CustomerPurchaseOrdersEmptyStateProps {
  hasActiveSearch: boolean
}

export const CustomerPurchaseOrdersEmptyState: FC<CustomerPurchaseOrdersEmptyStateProps> = ({ hasActiveSearch }) => (
  <InformationMissingAlert
    title={
      hasActiveSearch
        ? "No customer orders found"
        : "No Customer Purchase Orders (CPO) yet. Add a new one to get started."
    }
  />
)
